import type { Goal } from "instantdb/types";

export const HYDRATION_GOALS: Partial<Goal>[] = [
  {
    id: "achieve-3-liter-daily-hydration-level",
    symbol: "💧",
    title: "Achieve 3-Liter Daily Hydration Level",
    description:
      "Gradually build and maintain optimal daily water consumption for improved health and performance",
  },
  {
    id: "establish-optimal-electrolyte-balance",
    symbol: "⚡",
    title: "Establish Optimal Electrolyte Balance",
    description:
      "Create and implement a comprehensive system for maintaining proper electrolyte levels during all activities",
  },
  {
    id: "build-daily-water-tracking-habit",
    symbol: "💧",
    title: "Build Daily Water Tracking Habit",
    description: "Develop a simple system to track and maintain healthy daily water intake",
  },
];
